import { parseClientEnv } from '@disenchantment/config/client';

/**
 * Parsed and validated client environment.
 *
 * Imported by api.service and socket.service instead of each calling
 * parseClientEnv independently. This guarantees:
 *   - Validation runs exactly once.
 *   - The [Runtime] startup log fires exactly once.
 *   - A missing/invalid var throws before any network call is attempted.
 */
export const env = parseClientEnv(import.meta.env);

// ── Startup log ─────────────────────────────────────────────────────────────
// Visible in browser DevTools → Console on every page load.
// Use this to confirm the correct URLs are embedded in a deployed build.
console.log('[Runtime] Environment:', import.meta.env.MODE);
console.log('[Runtime] API URL:   ', env.VITE_API_URL);
console.log('[Runtime] Socket URL:', env.VITE_GATEWAY_URL);
